.compareBtnWrap {
  padding-bottom: 7px;
  flex-wrap: wrap;

  @media (min-width: 650px) {
    padding-top: 7px;
    float: right;
  }
}

.respondedButtons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .filledButtons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: var(--spacingMd);
  }
}

.bookButtonDisabled {
  justify-content: end;
}

.actionButtons {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacingMd);
}

.rolesActions {
  display: flex;
  flex-direction: row;
  gap: var(--spacingLg);
  justify-content: space-between;
  width: 100%;
  align-items: flex-end;

  .acceptedButtons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: var(--spacingMd);
  }
}

.declinedState {
  justify-content: flex-end;
  align-items: center;
}
